import styled from 'styled-components/macro';

export const StyledText = styled.p`
  color: #d00;
  min-height: 22px;
  white-space: pre-wrap;
`;